(function(){
  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
    window.addEventListener('load', fn);
    document.addEventListener('shopify:section:load', fn);
  }

  function initUl(ul){
    if (ul._peekInited) return;
    ul._peekInited = true;

    const comp = ul.closest('slider-component');
    const segs = comp?.querySelectorAll('.gallery-progress__seg') || [];
    if (!segs.length) return;

    const total = segs.length;

    function indexByScroll(){
      const first = ul.querySelector('li');
      const w = first ? first.getBoundingClientRect().width : ul.clientWidth * 0.905;
      const i = Math.round(ul.scrollLeft / Math.max(1, w));
      return Math.min(Math.max(i,0), total-1);
    }

    function render(){
      const idx = indexByScroll();
      segs.forEach((s,i)=> s.classList.toggle('is-active', i <= idx));
      const bar = comp.querySelector('.gallery-progress');
      if (bar){
        bar.setAttribute('aria-valuenow', String(idx+1));
      }
    }

    ul.addEventListener('scroll', render, {passive:true});
    window.addEventListener('resize', render);

    comp?.querySelectorAll('button[name="next"],button[name="previous"]').forEach(b=>{
      b.addEventListener('click', ()=> setTimeout(render, 60));
    });

    setTimeout(render, 100);
  }

  ready(()=>{
    document.querySelectorAll('ul.product__media-list.slider--mobile.peek-905').forEach(initUl);
  });
})();
